import React from 'react';
import BALON_PARADO from '@/features/balon-parado/balonParado.json';
import { Box, Typography } from '@mui/material';
import CustomModal from '@/DesignSystem/components/custom-modal/CustomModal';
import CustomImageComponent from '@/components/shared/custom/custom-image';
import { getMasterPhotoById } from '@/helpers/images-helper';
import { obtenerNombreLargoDelEquipo } from '@/data/equipos';

const BalonParadoModal = ({ open, onClose, teamId }) => {
    // Buscar el equipo por teamId
    const equipo = Object.values(BALON_PARADO).find((team) => team.teamId === teamId);
    const equipoName = obtenerNombreLargoDelEquipo(teamId);

    // Si no hay datos del equipo, no mostrar nada
    if (!equipo) {
        return null;
    }

    // Función reutilizable para renderizar secciones de jugadores
    const renderPlayerSection = (title, players) => (
        <Box sx={{ mb: 3 }}>
            <Typography
                variant="h6"
                sx={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: 'text.primary',
                    borderBottom: '1px solid',
                    borderColor: 'primary.main',
                    pb: 0.5,
                    mb: 2,
                }}
            >
                {title}
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    justifyContent: 'flex-start',
                }}
            >
                {players.map((player) => (
                    <Box
                        key={player.id}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            width: '90px',
                            justifyContent: 'center',
                            p: 1.5,
                            borderRadius: 2,
                            backgroundColor: 'background.default',
                            transition: 'all 0.2s ease-in-out',
                            border: '1px solid',
                            borderColor: 'border.light',
                            '&:hover': {
                                backgroundColor: 'background.paper',
                                transform: 'translateY(-2px)',
                                boxShadow: 2,
                            },
                        }}
                    >
                        <Box
                            sx={{
                                borderRadius: '50%',
                                overflow: 'hidden',
                                border: '1px solid',
                                borderColor: 'primary.main',
                                boxShadow: 1,
                            }}
                        >
                            <CustomImageComponent
                                src={getMasterPhotoById(player.id)}
                                alt={player.name}
                                width={80}
                                height={80}
                            />
                        </Box>
                        <Typography
                            variant="body2"
                            fontSize={13}
                            textAlign="center"
                            sx={{
                                maxWidth: '110px',
                                fontWeight: 500,
                                lineHeight: 1.2,
                                color: 'text.primary',
                                mt: 1,
                            }}
                        >
                            {player.name}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );

    return (
        <CustomModal
            open={open}
            onClose={onClose}
            title={`Balón Parado - ${equipoName}`}
            maxWidth="lg"
            width="95%"
            paperSx={{
                minHeight: '600px',
            }}
            contentSx={{ pt: 2 }}
        >
            <Box>
                {renderPlayerSection('Lanzadores de Penaltis', equipo.penaltis)}
                {renderPlayerSection('Lanzadores de Faltas Directas', equipo.faltasDirectas)}
                {renderPlayerSection(
                    'Lanzadores de Córners y Faltas Laterales',
                    equipo.cornersFaltasLaterales
                )}

                <Box
                    sx={{
                        p: 2,
                        borderRadius: 2,
                        backgroundColor: 'background.default',
                        border: '1px solid',
                        borderColor: 'border.light',
                        textAlign: 'center',
                        mt: 3,
                    }}
                >
                    <Typography
                        fontSize={12}
                        fontStyle={'italic'}
                        color="text.secondary"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1,
                        }}
                    >
                        <Box
                            component="span"
                            sx={{
                                width: 4,
                                height: 4,
                                borderRadius: '50%',
                                backgroundColor: 'primary.main',
                            }}
                        />
                        Datos de Don Quijote de la Cancha
                    </Typography>
                </Box>
            </Box>
        </CustomModal>
    );
};

export default BalonParadoModal;
